export default __webpack_public_path__ + "static/media/company3.d67a6002.svg";